<div>
  <div id="call-details-dialog">
    <div class="panel left-panel top-panel">
      <div class="title">Call summary</div>
      <div class="details-column">
        <ul class="call-list">
          <li class="call-list-item">
            <span class="call-detail-key">Call Status:</span>
            <span class="call-detail-value {{details.status}}">{{details.status}}</span>
          </li>
          <li class="call-list-item">
            <span class="call-detail-key">Source URI:</span>
            <span class="call-detail-value" title="{{details.srcUriBeforeManipulation}}">{{details.srcUriBeforeManipulation}}</span>
          </li>
          <li class="call-list-item">
            <span class="call-detail-key">Destination URI:</span>
            <span class="call-detail-value" title="{{details.dstUriBeforeManipulation}}">{{details.dstUriBeforeManipulation}}</span>
          </li>
          <li class="call-list-item">
            <span class="call-detail-key">Session Id:</span>
            <span class="call-detail-value" title="{{details.sessionId}}">{{details.sessionId}}</span>
          </li>
          <li class="call-list-item">
            <span class="call-detail-key">Termination reason:</span>
            <span class="call-detail-value">{{details.sipTerminationReason}}</span>
          </li>
          <li class="call-list-item" *ngIf="details.description">
            <span class="call-detail-key">Description:</span>
            <span class="call-detail-value break-line" title="{{details.description}}">{{details.description}}</span>
          </li>
        </ul>
        <div *ngIf="details.partial" class="is-partial-call">
          <span>* Partial information</span>
        </div>
      </div>
    </div>

    <div class="panel right-panel top-panel">
      <div class="title">Path summary</div>
      <div class="path-summary-content" #pathSummaryContent>
        <div class="path-summary-details">
          <div class="details-column left">
            <ul class="call-list">
              <li class="call-list-item">
                <span class="call-detail-key">Status:</span>
                <span class="call-detail-value {{selectedPath.status}}">{{selectedPath.status}}</span>
              </li>
              <li class="call-list-item">
                <span class="call-detail-key">Start time:</span>
                <span class="call-detail-value">{{selectedPath.armSetupTime | date: 'dd-MMM-yy HH:mm:ss'}}</span>
              </li>
              <li class="call-list-item">
                <span class="call-detail-key">Duration:</span>
                <span class="call-detail-value">{{getVoiceDuration(selectedPath.voiceDuration)}}</span>
              </li>
              <li class="call-list-item">
                <span class="call-detail-key">Router IP:</span>
                <span class="call-detail-value" title="{{selectedPath.routerName}}">{{selectedPath.routerName}}</span>
              </li>
              <li class="call-list-item">
                <span class="call-detail-key">Routing rule:</span>
                <span class="call-detail-value" title="{{selectedPath.routingRuleName}}">{{selectedPath.routingRuleName}}</span>
              </li>
              <li class="call-list-item">
                <span class="call-detail-key">Termination reason:</span>
                <span class="call-detail-value">{{selectedPath.sipTerminationReason}}</span>
              </li>
              <li class="call-list-item">
                <span class="call-detail-key">SIP reason:</span>
                <span class="call-detail-value">{{selectedPath.sipTerminationReasonDesc}}</span>
              </li>
            </ul>
          </div>
          <div class="details-column right">
            <ul class="call-list">
              <li class="call-list-item">
                <span class="call-detail-key">Source URI after manipulation:</span>
                <span class="call-detail-value" title="{{selectedPath.srcUriAfterManipulation}}">{{selectedPath.srcUriAfterManipulation}}</span>
              </li>
              <li class="call-list-item">
                <span class="call-detail-key">Destination URI after manipulation:</span>
                <span class="call-detail-value" title="{{selectedPath.dstUriAfterManipulation}}">{{selectedPath.dstUriAfterManipulation}}</span>
              </li>
              <li class="call-list-item" *ngIf="selectedPath.srcPeerConnectionName">
                <span class="call-detail-key">Incoming Peer Connection:</span>
                <span class="call-detail-value">{{selectedPath.srcPeerConnectionName}}</span>
              </li>
              <li class="call-list-item" *ngIf="selectedPath.destPeerConnectionName">
                <span class="call-detail-key">Outgoing Peer Connection:</span>
                <span class="call-detail-value">{{selectedPath.destPeerConnectionName}}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="manipulation-container" *ngIf="isManipulationExist() || !!selectedPath.userDefined1">
          <div class="show-more-less" (click)="toggeleMoreInfo(); scrollToBottom()">
            <i class="fa" [ngClass]="{'fa-chevron-up': showMorePathInfo, 'fa-chevron-down': !showMorePathInfo}"></i>
            <span>{{showMorePathInfo ? 'Less' : 'More'}}</span>
          </div>

          <div *ngIf="isManipulationExist() && showMorePathInfo && getManipulationBeforeRouting(selectedPath.manipulations).length > 0">
            <ac-line-separator separatorId="test-route-details-dialog-separator" title="Manipulation before route"></ac-line-separator>
            <div class="manipulation-grid">
              <manipulation-grid [data]="selectedPath.manipulations | acFunc: getManipulationBeforeRouting" gridId="before"></manipulation-grid>
            </div>
          </div>

          <div *ngIf="isManipulationExist() && showMorePathInfo && getManipulationDuringRouting(selectedPath.manipulations).length > 0">
            <ac-line-separator separatorId="test-route-details-dialog-separator" title="Manipulation during route"></ac-line-separator>
            <div class="manipulation-grid">
              <manipulation-grid [data]="selectedPath.manipulations | acFunc: getManipulationDuringRouting" gridId="during"></manipulation-grid>
            </div>
          </div>

          <ul class="call-list" *ngIf="!!selectedPath.userDefined1 && showMorePathInfo">
            <ac-line-separator separatorId="test-route-details-dialog-separator" title="More info"></ac-line-separator>
            <span class="call-detail-value">{{selectedPath.userDefined1}}</span>
          </ul>
        </div>

        <div class="max-unselected-rules-reached-label" *ngIf="details.maxUnselectedRulesReached === null">* This call does not contain information about unselected rules / policy studio</div>
        <div class="max-unselected-rules-reached-label" *ngIf="details.maxUnselectedRulesReached">* Maximum number of unselected rules to be shown is reached</div>

      </div>
    </div>

    <div class="panel right-panel bottom-panel">
      <div class="map-drop-area"
           [contextMenu]="callsMapMenu"
           [contextMenuSubject]="contextMenuData">

        <context-menu #callsMapMenu [menuClass]="!contextMenuData || contextMenuData.length === 0 ? 'hide-menu' : ''">
          <ng-template *ngFor="let action of contextMenuData"
                       contextMenuItem
                       (execute)="action.click()"
                       [visible]="action.visible"
                       [divider]="action.divider">
            <span [innerHtml]="action.html"></span>
          </ng-template>
        </context-menu>

        <div class="topology-actions">
          <mat-icon color="primary" class="topology-action" (click)="bringIntoView()">filter_center_focus</mat-icon>
          <mat-icon color="primary" class="topology-action" (click)="zoomIn()">zoom_in</mat-icon>
          <mat-icon color="primary" class="topology-action" (click)="zoomOut()">zoom_out</mat-icon>
        </div>

        <network-diagram *ngIf="showNetworkDiagram"
                         diagramId="call-details-diagram"
                         [initialDiagramOptions]="savedMapConfigurations"
                         [getClusteredEdgePropertiesByEdges]="getClusteredEdgePropertiesByEdges"
                         [getClusteredNodePropertiesByNodes]="getClusteredNodePropertiesByNodes"
                         (onDiagramReady)="onDiagramReady($event.diagramApi)"
                         (onContextMenu)="onContextMenu($event)"
                         class="network-diagram">
        </network-diagram>
      </div>
    </div>

    <div class="panel left-panel bottom-panel">
      <div class="title">Paths</div>
      <div class="paths-table-container">
        <div class="paths-table">
          <table mat-table [dataSource]="pathsList">
            <ng-container matColumnDef="pathName">
              <td mat-cell *matCellDef="let element"> {{element.displayName}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <td mat-cell *matCellDef="let element">
                <i class="fa" [ngClass]="element.icon"></i>
              </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                class="path-row" [ngClass]="{'highlight': selectedPath.id === row.id, 'unselected': row.unselectedRule}" (click)="updatePathDetails(row)">
            </tr>
          </table>
        </div>
        <div class="show-unselected-rules">
          <mat-checkbox name="showUnselectedRules" color="primary"
                        (ngModelChange)="showUnselectedRulesChange($event)"
                        [(ngModel)]="showUnselectedRules">
            Show unselected rules
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>
